import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const Task2Icon = forwardRef<SVGSVGElement, IconProps>(function Task2Icon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.76971 13.2206C1.5394 12.1843 1.44 10.82 1.44 9C1.44 7.17999 1.5394 5.81574 1.76971 4.77943C1.99639 3.75947 2.33029 3.14756 2.73892 2.73892C3.14756 2.33029 3.75947 1.99639 4.77943 1.76971C5.81574 1.5394 7.17999 1.44 9 1.44C10.82 1.44 12.1843 1.5394 13.2206 1.76971C14.2405 1.99639 14.8524 2.33029 15.2611 2.73892C15.6697 3.14756 16.0036 3.75947 16.2303 4.77943C16.4606 5.81574 16.56 7.17999 16.56 9C16.56 10.82 16.4606 12.1843 16.2303 13.2206C16.0036 14.2405 15.6697 14.8524 15.2611 15.2611C14.8524 15.6697 14.2405 16.0036 13.2206 16.2303C12.1843 16.4606 10.82 16.56 9 16.56C7.17999 16.56 5.81574 16.4606 4.77943 16.2303C3.75947 16.0036 3.14756 15.6697 2.73892 15.2611C2.33029 14.8524 1.99639 14.2405 1.76971 13.2206ZM9 18C1.5885 18 0 16.4115 0 9C0 1.5885 1.5885 0 9 0C16.4115 0 18 1.5885 18 9C18 16.4115 16.4115 18 9 18Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M7.27425 4.60277C7.54461 4.87314 7.54461 5.31148 7.27425 5.58184L5.40502 7.45107C5.13465 7.72144 4.69631 7.72144 4.42595 7.45107L3.80287 6.828C3.53251 6.55763 3.53251 6.11929 3.80287 5.84893C4.07323 5.57856 4.51158 5.57856 4.78194 5.84893L4.91548 5.98247L6.29518 4.60277C6.56554 4.33241 7.00389 4.33241 7.27425 4.60277Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8.5764 6.33846C8.5764 5.95611 8.88636 5.64615 9.26871 5.64615H13.6303C14.0126 5.64615 14.3226 5.95611 14.3226 6.33846C14.3226 6.72081 14.0126 7.03077 13.6303 7.03077H9.26871C8.88636 7.03077 8.5764 6.72081 8.5764 6.33846Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M7.27425 10.4182C7.54461 10.6885 7.54461 11.1269 7.27425 11.3972L5.40502 13.2665C5.13465 13.5368 4.69631 13.5368 4.42595 13.2665L3.80287 12.6434C3.53251 12.373 3.53251 11.9347 3.80287 11.6643C4.07323 11.3939 4.51158 11.3939 4.78194 11.6643L4.91548 11.7979L6.29518 10.4182C6.56554 10.1478 7.00389 10.1478 7.27425 10.4182Z"
        fill={color || 'currentColor'}
      />
      <path
        d="M8.5764 12.1538C8.5764 11.7715 8.88636 11.4615 9.26871 11.4615H13.6303C14.0126 11.4615 14.3226 11.7715 14.3226 12.1538C14.3226 12.5362 14.0126 12.8462 13.6303 12.8462H9.26871C8.88636 12.8462 8.5764 12.5362 8.5764 12.1538Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
